import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    INFRA_LOGBOOK_LIST,
    INFRA_LOGBOOK_ADD,
    INFRA_LOGBOOK_UPDATE,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA,
    INFRA_LOGBOOK_SAVE_CONTRACT,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES,
} from '../../actions';
import {
    InfrastructureLogbookList,
    InfrastructureLogbookListSuccess,
    InfrastructureLogbookListError,
    InfrastructureLogbookAddSuccess,
    InfrastructureLogbookAddError,
    InfrastructureLogbookUpdateSuccess,
    InfrastructureLogbookUpdateError,
    InfrastructureLogbookContractERPDataSuccess,
    InfrastructureLogbookContractERPDataError,
    InfrastructureLogbookSaveContractSuccess,
    InfrastructureLogbookSaveContractError,
    InfrastructureLogbookUpdateContractNotesSuccess,
    InfrastructureLogbookUpdateContractNotesError,
} from '../../actions';

const getToken = async () => await authFB.currentUser.getIdToken(true);

const postJson = async (endpoint, body) => {
    const token = await getToken();
    const response = await fetch(servicePath + endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', token },
        body: JSON.stringify(body || {})
    });
    return response.json();
};

function* onList({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/list', payload || {});
        yield put(InfrastructureLogbookListSuccess(response));
    } catch (error) {
        yield put(InfrastructureLogbookListError(error));
    }
}

function* onAdd({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/add', { data: payload });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureLogbookAddSuccess(payload.is_follow_up_action
                ? { ...response, isFollowUpAction: true, entry: payload }
                : response));
            yield put(InfrastructureLogbookList(undefined, undefined, undefined, {
                id_contract_logbook: payload.id_contract_logbook
            }));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureLogbookAddError(response));
        }
    } catch (error) {
        yield put(InfrastructureLogbookAddError(error));
    }
}

function* onUpdate({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/update', { data: payload });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureLogbookUpdateSuccess(response));
            yield put(InfrastructureLogbookList(undefined, undefined, undefined, {
                id_contract_logbook: payload.id_contract_logbook
            }));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureLogbookUpdateError(response));
        }
    } catch (error) {
        yield put(InfrastructureLogbookUpdateError(error));
    }
}

function* onContractERPData({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/contractERPData', { contract: payload });
        yield put(InfrastructureLogbookContractERPDataSuccess(response.data || []));
    } catch (error) {
        yield put(InfrastructureLogbookContractERPDataError(error));
    }
}

function* onSaveContract({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/saveContract', { data: payload });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureLogbookSaveContractSuccess(response));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureLogbookSaveContractError(response));
        }
    } catch (error) {
        NotificationManager.error('No fue posible guardar el contrato.', 'Error', 3000, null, null, '');
        yield put(InfrastructureLogbookSaveContractError(error));
    }
}

function* onUpdateContractNotes({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureLogbook/updateContractNotes', { data: payload });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureLogbookUpdateContractNotesSuccess({ field: payload.field }));
            yield put(InfrastructureLogbookList(undefined, undefined, undefined, {
                id_contract_logbook: payload.id_contract_logbook
            }));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureLogbookUpdateContractNotesError({ field: payload.field, error: response }));
        }
    } catch (error) {
        const label = payload.field === 'summary' ? 'el resumen' : 'las observaciones';
        NotificationManager.error(`No fue posible guardar ${label}.`, 'Error', 3000, null, null, '');
        yield put(InfrastructureLogbookUpdateContractNotesError({ field: payload.field, error }));
    }
}

export function* watchLogbookList() {
    yield takeEvery(INFRA_LOGBOOK_LIST, onList);
}

export function* watchLogbookAdd() {
    yield takeEvery(INFRA_LOGBOOK_ADD, onAdd);
}

export function* watchLogbookUpdate() {
    yield takeEvery(INFRA_LOGBOOK_UPDATE, onUpdate);
}

export function* watchLogbookContractERPData() {
    yield takeEvery(INFRA_LOGBOOK_CONTRACT_ERP_DATA, onContractERPData);
}

export function* watchLogbookSaveContract() {
    yield takeEvery(INFRA_LOGBOOK_SAVE_CONTRACT, onSaveContract);
}

export function* watchLogbookUpdateContractNotes() {
    yield takeEvery(INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES, onUpdateContractNotes);
}

export default function* rootSaga() {
    yield all([
        fork(watchLogbookList),
        fork(watchLogbookAdd),
        fork(watchLogbookUpdate),
        fork(watchLogbookContractERPData),
        fork(watchLogbookSaveContract),
        fork(watchLogbookUpdateContractNotes)
    ]);
}